import { render, staticRenderFns } from "./MessageStudentList.vue?vue&type=template&id=0630499d&scoped=true&"
import script from "./MessageStudentList.vue?vue&type=script&lang=js&"
export * from "./MessageStudentList.vue?vue&type=script&lang=js&"
import style0 from "./MessageStudentList.vue?vue&type=style&index=0&id=0630499d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0630499d",
  null
  
)

export default component.exports